<template>
  <div class="achievementStatistics">
    <headerNotice routerName="业务员业绩统计"></headerNotice>
    <div v-loading="loading" class="content">
      <div class="header">
        <dateSelector @dateChange="getDataByTime"/>
        <!-- <div class="export">
          <el-button type="text" style="color: #000;">
            统计说明
            <i class="el-icon-question"></i>
          </el-button>
          <el-button type="text" style="color: #000;">
            <i class="el-icon-printer"></i>
            导出
          </el-button>
        </div>-->
      </div>
      <sum-list :list="dataSum"/>
      <el-table
        :data="performanceData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column align="center" type="index" label="序号"></el-table-column>
        <el-table-column align="center" prop="salesmanName" label="业务员"></el-table-column>
        <el-table-column align="center" prop="customerCount" label="关联客户数"></el-table-column>
        <el-table-column align="center" prop="orderedCustomerCount" label="订货客户数"></el-table-column>
        <el-table-column align="center" prop="orderCount" label="订单数" sortable></el-table-column>
        <el-table-column align="center" prop="commission" label="提成金额(￥)" sortable></el-table-column>
        <el-table-column align="center" prop="amount" label="订单金额(￥)" sortable></el-table-column>
        <el-table-column align="center" label="客单价(￥)" sortable>
          <template slot-scope="scope">{{priceFilter(scope.row.averageAmount)}}</template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync='currentPage'
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        center
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
import dateSelector from "./dateSelector.vue";
import sumList from "./sumList.vue";
export default {
  components: {
    headerNotice,
    sumList,
    dateSelector
  },
  props: {},
  data() {
    return {
      loading: false,
      duration: [],
      pageSize: 10,
      totalCount: 0,
      currentPage: 1,
      dataSum: [],
      performanceData: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 更改时间重新发请求
    getDataByTime(date) {
      this.duration = date;
      this.getStatisticsByPerformance({
        StartTime: date[0],
        EndTime: date[1],
        MaxResultCount: this.pageSize
      });
      this.currentPage = 1
    },
    // 业绩数据
    getStatisticsByPerformance(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminStatistics/GetStatisticsByPerformance",
        params: params,
        success(res) {
          // console.log(res)
          self.performanceData = res.items;
          self.totalCount = res.totalCount;
          // self.chartData = self.initChartData(self.orderData)
          self.dataSum = self.getDataSum(res);
          // self.initChart();
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    // 总数据
    getDataSum(data) {
      return [
        { title: "订货单数", value: data.totalOrderNum },
        { title: "订货客户", value: data.totalOrderedCustomerNum },
        { title: "提成金额", value: data.totalCommission },
        { title: "订货金额", value: data.totalOrderedAmountNum },
        {
          title: "客单价",
          value: this.priceFilter(data.averageOrderedAmountNum)
        }
      ];
    },
    //一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
        MaxResultCount: val,
        StartTime: this.duration[0],
        EndTime: this.duration[1]
      };
      this.getStatisticsByPerformance(params);
    },
    //跳转到指定页
    handleCurrentChange(val) {
      let skipCount = (val - 1) * this.pageSize;
      let params = {
        SkipCount: skipCount,
        MaxResultCount: this.pageSize,
        StartTime: this.duration[0],
        EndTime: this.duration[1]
      };
      this.getStatisticsByPerformance(params);
    },
    priceFilter(price) {
      return price.toFixed(2);
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.achievementStatistics {
  .content {
    padding: 0 50px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
  }
  .pagination-wrapper {
    text-align: center;
    margin: 30px auto;
  }
}
</style>